export default __webpack_public_path__ + "static/media/mb-chevron-down.bb99465b.svg";